import { AccountDatasource } from './../user_app/datasources/account_datasource';
import { TransferConfiguration } from './config/transfer_configuration';
angular
  .module('capability-ng-transfer', [
    'ngSanitize',
    'ngAria',
    'ngMessages',
    'ngAnimate',
    'ct.ui.router.extras.core',
    'ct.ui.router.extras.dsr',
    'ct.ui.router.extras.sticky',
    'vendor'
  ])
  .run((ngTransferConfiguration: TransferConfiguration, ngAccountDatasource: AccountDatasource) => {
    ngTransferConfiguration.configureAccount(ngAccountDatasource);
  });



// WEBPACK FOOTER //
// ./app/lib/transfer/core.ts